import { render, staticRenderFns } from "./addBusinessOpportunity.vue?vue&type=template&id=a05ae77a&scoped=true"
import script from "./addBusinessOpportunity.vue?vue&type=script&lang=js"
export * from "./addBusinessOpportunity.vue?vue&type=script&lang=js"
import style0 from "./addBusinessOpportunity.vue?vue&type=style&index=0&id=a05ae77a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05ae77a",
  null
  
)

export default component.exports